import {
  Action,
  AnyAction,
  configureStore,
  ThunkAction,
  ThunkDispatch,
} from "@reduxjs/toolkit";

import { reducer as counterReducer } from "./CounterStore/counterSlice";
import { reducer as currentClinicianReducer } from "./ClinicianStore/clinicianSlice";
import { reducer as clinicReducer } from "./ClinicStore/clinicSlice";
import { reducer as patientRegionsReducer } from "./PatientRegionsStore/patientRegionsSlice";
import { reducer as patientReducer } from "./PatientStore/patientSlice";
import { reducer as examReducer } from "./ExamStore/examSlice";
import { reducer as examGroupReducer } from "./ExamGroupStore/examGroupSlice";
import { reducer as examMLResultReducer } from "./ExamMLResultStore/examMLResultSlice";
import { reducer as loadingReducer } from "./LoadingStore/loadingSlice";
import { reducer as atheleteReducer } from "./AtheleteStore/athleteSlice";

export const store = configureStore({
  // TODO: add middlewares
  reducer: {
    currentClinician: currentClinicianReducer,
    counter: counterReducer,
    patientRegions: patientRegionsReducer,
    patient: patientReducer,
    exam: examReducer,
    examGroup: examGroupReducer,
    examMLResult: examMLResultReducer,
    loading: loadingReducer,
    clinic: clinicReducer,
    athletes: atheleteReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk<T = void> = ThunkAction<
  T,
  RootState,
  null,
  Action<string>
>;
export type TypedDispatch = ThunkDispatch<RootState, any, AnyAction>;
